import {
  SimpleGalleryCollector,
  SimplePolicyDetailInfo,
  SimpleUser,
  TraitFilterData,
} from "kreate-common/modules/business-types";
import { z } from "zod";

const BaseParams = z.object({
  searchQuery: z.string().optional(),
  // sorting and paginating
  offset: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
});

export const Params = z.union([
  BaseParams.extend({
    aggregateType: z.enum([
      "forsale_artist",
      "forsale_policy",
      "forsale_collector",
    ]),
  }),
  BaseParams.extend({
    aggregateType: z.enum(["policy_trait", "policy_collector"]),
    policyId: z.string(),
  }),
]);

export type Params = z.infer<typeof Params>;

export const Result = z.union([
  z.object({
    aggregateType: z.literal("forsale_artist"),
    docs: SimpleUser.array(),
    count: z.number(),
  }),
  z.object({
    aggregateType: z.literal("forsale_policy"),
    docs: SimplePolicyDetailInfo.array(),
    count: z.number(),
  }),
  z.object({
    aggregateType: z.literal("forsale_collector"),
    docs: SimpleGalleryCollector.array(),
    count: z.number(),
  }),
  z.object({
    aggregateType: z.literal("policy_trait"),
    docs: TraitFilterData.array(),
    count: z.number(),
  }),
  z.object({
    aggregateType: z.literal("policy_collector"),
    docs: SimpleGalleryCollector.array(),
    count: z.number(),
  }),
]);

export type Result = z.infer<typeof Result>;

export type GetSecondaryArtworkFilterData$Params = Params;
export const GetSecondaryArtworkFilterData$Params = Params;
export type GetSecondaryArtworkFilterData$Result = Result;
export const GetSecondaryArtworkFilterData$Result = Result;
